// extracted by mini-css-extract-plugin
export default {"value":"_33o70___Metric-module__value"};